import React, { useState, useEffect, useCallback } from 'react';
import { Users, Inbox, Clock } from 'lucide-react';
import api from '../services/api';
import socketService from '../services/socketService';
import '../styles/AgentOverview.css';

function AgentOverview({ onlineUserIds = [] }) {
  const [data, setData] = useState({ agents: [], unassigned: 0, pending: 0 });
  const [loading, setLoading] = useState(true);

  const fetchOverview = useCallback(async () => {
    try {
      const r = await api.get('/conversations/overview');
      setData(r.data);
    } catch (e) {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    fetchOverview();
    const refresh = () => fetchOverview();
    socketService.on('conversation:updated', refresh);
    socketService.on('conversation:assigned', refresh);
    return () => {
      socketService.off('conversation:updated', refresh);
      socketService.off('conversation:assigned', refresh);
    };
  }, [fetchOverview]);

  if (loading) return <div className="overview-loading">Carregando visão geral...</div>;

  const total = data.agents.reduce((s, a) => s + (a.open_count || 0), 0) + (data.unassigned || 0);

  return (
    <div className="agent-overview">
      <div className="overview-header">
        <h2>Visão Geral dos Atendimentos</h2>
        <p>Quem está atendendo o quê agora</p>
      </div>

      <div className="overview-stats">
        <div className="stat-card stat-open">
          <Users size={20} />
          <div>
            <span className="stat-value">{total}</span>
            <span className="stat-label">Em atendimento</span>
          </div>
        </div>
        <div className="stat-card stat-unassigned">
          <Inbox size={20} />
          <div>
            <span className="stat-value">{data.unassigned}</span>
            <span className="stat-label">Sem atendente</span>
          </div>
        </div>
        <div className="stat-card stat-pending">
          <Clock size={20} />
          <div>
            <span className="stat-value">{data.pending}</span>
            <span className="stat-label">Aguardando</span>
          </div>
        </div>
      </div>

      <div className="overview-agents">
        {data.agents.map(agent => {
          const isOnline = onlineUserIds.includes(String(agent.agent_id));
          return (
            <div key={agent.agent_id} className="agent-card">
              <div className="agent-card-header">
                <div className="agent-avatar-wrap">
                  <div className="agent-card-avatar">
                    {agent.agent_name?.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?'}
                  </div>
                  <span className={`agent-presence-dot ${isOnline ? 'online' : 'offline'}`} />
                </div>
                <div className="agent-card-info">
                  <span className="agent-card-name">{agent.agent_name}</span>
                  <span className={`agent-status-pill ${isOnline ? 'online' : 'offline'}`}>
                    {isOnline ? 'Online' : 'Offline'}
                  </span>
                </div>
                <div className="agent-conv-count">
                  <span className="count-num">{agent.open_count}</span>
                  <span className="count-lbl">atend.</span>
                </div>
              </div>
              <div className="agent-workload-bar">
                <div
                  className="agent-workload-fill"
                  style={{ width: `${Math.min(100, (agent.open_count / 10) * 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AgentOverview;
